// WHY NOT — reusable countdown timer for the countdown-banner section.
(function () {
  'use strict';

  function tick(root) {
    var target = new Date(root.getAttribute('data-countdown')).getTime();
    var daysEl = root.querySelector('[data-unit="days"]');
    var hoursEl = root.querySelector('[data-unit="hours"]');
    var minsEl = root.querySelector('[data-unit="minutes"]');
    var secsEl = root.querySelector('[data-unit="seconds"]');
    var isFirstTick = true;

    function setUnit(el, value) {
      if (!el) return;
      var next = String(value).padStart(2, '0');
      if (el.textContent === next) return;
      el.textContent = next;
      if (isFirstTick) return;
      el.classList.remove('is-updating');
      void el.offsetWidth; // restart the animation even if triggered again mid-flight
      el.classList.add('is-updating');
    }

    function update() {
      var diff = Math.max(0, target - Date.now());
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var mins = Math.floor((diff / (1000 * 60)) % 60);
      var secs = Math.floor((diff / 1000) % 60);
      setUnit(daysEl, days);
      setUnit(hoursEl, hours);
      setUnit(minsEl, mins);
      setUnit(secsEl, secs);
      isFirstTick = false;
      if (diff <= 0) clearInterval(interval);
    }
    update();
    var interval = setInterval(update, 1000);
  }

  document.querySelectorAll('[data-why-not-countdown]').forEach(tick);
})();
